import {setSidebar} from '../../services/router';
import {Sidebar} from '../../components';

setSidebar(() => {
  return <Sidebar />;
});
